import { css, keyframes } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const layout = (height?: number) =>
  css({
    alignItems: 'center',
    display: 'flex',
    columnGap: Spacing.XS,
    justifyContent: 'center',
    height: height ?? '100%',
    width: '100%',
  })

type DotStyles = {
  /** The colours the dot passes through each second, in order. */
  colors: readonly [string, string, string]
  dotSize: number
}

export const dot = ({ colors: [first, second, third], dotSize }: DotStyles) =>
  css({
    // A CSS animation, not one driven from script: the browser stops it with
    // the element, and it costs the main thread nothing while it runs.
    animation: `${keyframes({
      '0%': { backgroundColor: first },
      '50%': { backgroundColor: second },
      '100%': { backgroundColor: third },
    })} 1s ease-in-out infinite`,
    borderRadius: '100%',
    height: dotSize,
    width: dotSize,
  })
